<template>
    <vx-card title="New Product">
        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span> Product Name</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <vs-input class="w-full" v-model="productName" />
            </div>
        </div>
        
        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span>Product Unique Name</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <v-select data-vv-validate-on="blur"  name="uniqueName"
                    v-model="uniqueName" v-validate="'required'" label="uniqueName" :options="uniqueNameOptions"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'" />
            </div>
        </div>
     



        <div class="vx-row">
            <div class="vx-col sm:w-2/3 w-full ml-auto">
                <vs-button @click="createProduct" class="mr-3 mb-2">Submit</vs-button>
                <vs-button color="warning" type="border" class="mb-2"
                    @click="packageName = packageCount = input3 = packageDuration = packagePrice = packageDescription = ''; check1 = false;">Reset Form</vs-button>
            </div>
        </div>
    </vx-card>
</template>

<script>
    import vSelect from 'vue-select'

    export default {
        components: {
            'v-select': vSelect
        },
        
        data() {
            return {
                productName: '',
                uniqueName: '',
                uniqueNameOptions: [ "OCR_NFC", "FACE_MATCHING", "LIVENESS" ],
            }
        },
        methods: {
            createProduct(){
                this.$vs.loading()
                const payload = new FormData();
                payload.append("productName", this.productName)
                payload.append("uniqueName", this.uniqueName)

                this.$store.dispatch('product/createProduct',payload)
                .then(response => {
                     this.$vs.loading.close()
                        this.$vs.notify({
                            title: 'Successfull',
                            text: response.data.message,
                            iconPack: 'feather',
                            icon: 'icon-check-circle',
                            color: 'success'
                        })
                        setTimeout(()=> this.$router.push('/products-list'), 1000)
                })
                .catch(error =>{
                    this.$vs.loading.close()
                        this.$vs.notify({
                            title: 'Error',
                            text: error.message,
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                })
            },

          
        }
    }
</script>

<style>

</style>